import React, { Fragment } from 'react'
import About from '../About/About'
import Certificates from '../Certificates/Certificates'
import Contact from '../Contact/Contact'
import Experience from '../Experience/Experience'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Intro from '../Intro/Intro'
import Portfolio from '../Portfolio/Portfolio'
import Services from '../Services/Services'

const Layout = () => {
  return <Fragment>
    <Header/>
    <Intro/>
    <About/>
    <Services/>
    <Experience/>
    <Portfolio/>
    <Certificates/>
    <Contact/>
    <Footer/>
  </Fragment>
}

export default Layout